<template>
  <div>
    <div class="backed" v-if="detailData.apprStatus == 3 || detailData.apprStatus == 4">
      <img src="/static/err-icon.png" alt="" />
      <span v-if="detailData.apprStatus == 4" class="back-title">退回原因：</span>
      <span v-if="detailData.apprStatus == 3" class="back-title">拒绝原因：</span>
      <span class="back-msg">{{ detailData.apprOpinion }}</span>
    </div>
    <el-form :inline="true" :rules="rules" :model="detailData" ref="ruleForm">
      <dialogPanel>
        <ChapterHead>
          <span v-if="dataMode == 'add'">基础信息</span>
          <span v-else>{{'患儿编号：' + (detailData.childId || '')}}</span>
          <template #extra>
            <!-- <el-button :loading="loading" v-if="!readOnly" type="primary" icon="el-icon-s-release" size="small"
                      @click="saveData">暂存</el-button>
            <el-button :loading="loading" v-if="!readOnly" type="primary" icon="el-icon-success" size="small"
                      @click="submitConfrim">提交</el-button>
            <el-button :loading="loading" type="primary" icon="el-icon-close" size="small" @click="back">关闭</el-button> -->
            <!--      相似患儿验证中-->
<!--            <span style="align-items: center" v-if="detailData.apprStatus==null">-->
<!--              <img src="/static/err-icon.png" style="width: 20px;height: 20px;display: inline-block;vertical-align: middle;" alt="" />-->
<!--              <span style="display: inline-block;vertical-align: middle;color: #dc243e;">相似患儿检验中，请联系业务人员</span>-->
<!--            </span>-->
            <img src="/static/status-icon.png" style="width: 15px;height: 15px;margin-right: 6px; vertical-align: middle;" alt="">
<!--            <span v-if="detailData.apprStatus==5" style="vertical-align: middle;">审核中</span>-->
<!--            <span v-else style="vertical-align: middle;">{{detailData.apprStatusText || (dataMode == 'add' ? '未提交' : '')}}</span>-->
            <span v-if="(detailData.apprStatus==8 && dataMode == 'add') || (detailData.apprStatus===0 && dataMode == 'modify')" style="vertical-align: middle;">未提交</span>
            <span v-else-if="detailData.apprStatus==8 && dataMode == 'modify'" style="vertical-align: middle;color: #dc243e;">{{detailData.apprStatus==8?'相似患儿检验中，请联系业务人员':''}}</span>
            <span v-else-if="detailData.apprStatus==5" style="vertical-align: middle;">审核中</span>
            <span v-else style="vertical-align: middle;">{{detailData.apprStatusText}}</span>

          </template>
        </ChapterHead>

        <div class="screen-view">
          <div class="screen-left">
            <img src="/static/default-avatar.png" class="child-head" alt="" />
          </div>
          <div class="screen-right">
            <el-row>
              <el-col :span="6">
                <el-form-item label="患儿姓名" prop="childName">
                  <el-input v-model="detailData.childName" type="text" :disabled="readOnly || detailData.isAddDiseases == 1" size="small" @blur="checkSimilarChildBaseInfo"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="性别" prop="sex">
                  <el-radio-group v-model="detailData.sex" class="my-radio" :disabled="readOnly || detailData.isAddDiseases == 1" @change="checkSimilarChildBaseInfo">
                    <el-radio :label="'1'">男</el-radio>
                    <el-radio :label="'0'">女</el-radio>
                    <el-radio :label="'3'">未知</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="身份证" prop="hasIdNumber">
                  <el-radio-group v-model="detailData.hasIdNumber" :disabled="readOnly || detailData.isAddDiseases == 1" @change="hasIdNumberVal(detailData.hasIdNumber)">
                    <el-radio :label="1">有</el-radio>
                    <el-radio :label="0">无</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col :span="6" v-if="detailData.hasIdNumber == 1 ||detailData.hasIdNumber == null ">
                <el-form-item label="身份证号" prop="idNumber">
                  <el-input v-model="detailData.idNumber" type="text" :disabled="readOnly || detailData.isAddDiseases == 1" @change="idNumberChange" size="small"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6" v-else>
                <el-form-item label="身份证号">
                  <el-input disabled size="small" value="-"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="6">
                <el-form-item label="出生日期" prop="birthday" >
                  <el-date-picker v-model="detailData.birthday" :disabled="readOnly || detailData.isAddDiseases == 1 || detailData.hasIdNumber == 1" type="date" size="small"
                                  value-format="timestamp" format="yyyy-MM-dd" placeholder="选择日期" :picker-options="pickerOptions" @change="checkSimilarChildBaseInfo">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="民族" prop="nation">
                  <DictionarySelect v-model="detailData.nation" tableType="ay" tableCode="C00002" :lazy="true"
                                    :disabled="readOnly"></DictionarySelect>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="监护人电话" prop="guardPhone">
                  <el-input v-model="detailData.guardPhone" type="text" :disabled="readOnly" size="small"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="其他电话" prop="guardOtherPhone">
                  <el-input v-model="detailData.guardOtherPhone" type="text" :disabled="readOnly" size="small"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="户口所在地" prop="location">
                  <LocationCascader v-model="detailData.location" :options="[{
                      value: detailData.province,
                      label: detailData.provinceText,
                      leaf: false,
                      children: [{
                        value: detailData.city,
                        label: detailData.cityText,
                        leaf: false,
                        valueParentId: detailData.province,
                        children: [{
                          value: detailData.county,
                          label: detailData.countyText,
                          leaf: true,
                          valueParentId: detailData.city
                        }]
                      }]
                    }]" :disabled="readOnly || detailData.isAddDiseases == 1"
                                    @change="checkSimilarChildBaseInfo"
                  >
                  </LocationCascader>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="详细地址" prop="fullAddr">
                  <el-input v-model="detailData.fullAddr" type="text" :row="2" :disabled="readOnly" size="small"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="常住地址" prop="liveAddr">
                  <el-input v-model="detailData.liveAddr" type="text" :row="2" :disabled="readOnly" size="small"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="监护人微信号" prop="guardWechat">
                  <el-input v-model="detailData.guardWechat" type="text" :disabled="readOnly" size="small"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
	          <el-row>
		          <el-col :span="6">
			          <el-form-item label="住院号" prop="inHospitalNo" :rules="[{ required: currentHospital.isAuto == 1, message: '请输入住院号', trigger: 'change' }]">
				          <div v-if="readOnly">
					          <el-input v-if="detailData.inHospitalNoSet" v-model="detailData.inHospitalNoSet" type="text" :disabled="readOnly" size="small"></el-input>
					          <el-input v-else disabled size="small" value="-"></el-input>
				          </div>
				          <el-input v-else v-model="detailData.inHospitalNo" type="text" :disabled="readOnly" size="small"></el-input>
			          </el-form-item>
		          </el-col>
		          <el-col :span="6" v-if="currentHospital.isShowInHospitalTime == 1 || detailData.isShowInHospitalTime == 1">
			          <el-form-item label="入院时间" prop="inHospitalTime" :rules="[{ required: currentHospital.isAuto == 1, message: '请输入入院时间', trigger: 'change' }]">
				          <div v-if="readOnly">
					          <el-date-picker v-if="detailData.inHospitalTime" v-model="detailData.inHospitalTime" :disabled="readOnly" type="date" size="small"
					                          value-format="timestamp" format="yyyy-MM-dd" placeholder="选择时间" :picker-options="pickerOptions">
					          </el-date-picker>
					          <el-input v-else disabled size="small" value="-"></el-input>
				          </div>
				          <el-date-picker v-else v-model="detailData.inHospitalTime" :disabled="readOnly" type="date" size="small"
				                          value-format="timestamp" format="yyyy-MM-dd" placeholder="选择时间" :picker-options="pickerOptions">
				          </el-date-picker>
			          </el-form-item>
		          </el-col>
<!--              <el-col :span="6" v-if="readOnly">-->
<!--                <template v-if="currentHospital.isShowInHospitalTime == 1 || detailData.isShowInHospitalTime == 1">-->
<!--                  <el-form-item label="住院流水号" prop="inHospitalSerialNo">-->
<!--                    <el-input type="text" size="small" disabled  :value="detailData.inHospitalSerialNo || '-'"></el-input>-->
<!--                  </el-form-item>-->
<!--                </template>-->
<!--              </el-col>-->

              <el-col :span="6" v-show="currentHospital.isAuto==1 || detailData.isAuto==1">
                  <div  v-if="!readOnly && currentHospital.isShowInHospitalNumber == 1">
                    <el-form-item label="住院流水号" prop="inHospitalSerialNo" :rules="[{required: currentHospital.isShowInHospitalNumber == 1, message: '请输入住院流水号', trigger: 'blur' }]">
                      <el-input
                        v-model="detailData.inHospitalSerialNo"
                        type="text"
                        size="small"
                      ></el-input>
                    </el-form-item>
                  </div>
                  <div v-if="readOnly">
                      <el-form-item label="住院流水号" prop="inHospitalSerialNo">
                        <el-input
                          :value="detailData.inHospitalSerialNo || '-'"
                          type="text"
                          size="small"
                          disabled
                        ></el-input>
                      </el-form-item>
                  </div>
              </el-col>
            </el-row>

              <!-- <el-row>
                <el-col :span="6">
                  <el-form-item label="监护人身份证" prop="guardIdNumber">
                    <el-input v-model="detailData.guardIdNumber" type="text" :disabled="readOnly" size="small"></el-input>
                  </el-form-item>
                </el-col>
              </el-row> -->
            <ChapterHead v-if="isWelfareBaby" :level="2" :showWarning="true">
              <span>支付宝相关信息</span>
              <span slot="warning">所选病种中包含公益宝贝病种，请填写支付宝相关信息。</span>
            </ChapterHead>
            <el-row v-if="isWelfareBaby">
              <el-col :span="6" v-if="isWelfareBaby && (detailData.apprStatus == 4 ? !!detailData.loginAccount : true)">
                <el-form-item label="登录手机号" prop="loginAccount">
                  <el-input type="text" v-model="detailData.loginAccount" :disabled="readOnly || detailData.apprStatus == 4" size="small"></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="6" v-if="isWelfareBaby && !detailData.apprStatus && detailData.apprStatus != 4">
                  <el-form-item label="验证码" class="getMsg-box" prop="captcha">
                    <MsgCodeInput v-model="detailData.captcha" :tel="detailData.loginAccount"></MsgCodeInput>
                  </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="支付宝姓名" prop="loginUserName">
                  <el-input type="text" v-model="detailData.loginUserName" :disabled="readOnly || detailData.apprStatus == 4" size="small"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="支付宝身份证" prop="loginIdNumber">
                  <el-input type="text" v-model="detailData.loginIdNumber" :disabled="readOnly || detailData.apprStatus == 4" size="small"></el-input>
                </el-form-item>
              </el-col>
<!--              <el-col :span="6">
                <el-form-item label="支付宝账号" prop="loginUserId">
                  <el-input type="text" v-model="detailData.loginUserId" :disabled="readOnly || detailData.apprStatus == 4" size="small"></el-input>
                </el-form-item>
              </el-col>-->
              <el-col :span="6">
                <el-form-item label="与患儿关系" prop="loginRelation">
                  <DictionarySelect
                    v-model="detailData.loginRelation"
                    tableCode="CHILD_RELATION"
                    :lazy="true"
                    :disabled="readOnly || detailData.apprStatus == 4">
                  </DictionarySelect>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>
      </dialogPanel>
      <el-collapse :value="['1', '2', '3']" >
        <MyCollapse title="病历信息"  iconPath="/static/de-zmr.png"  name="1">
            <ChildCase
              ref="childCase"
              :helpReqId="detailData.helpReqId"
              :child="detailData"
              :dataMode="dataMode"
              :readOnly="readOnly"
              @hospitalChange="hospitalChange"
              @diseaseChange="diseaseChange">
            </ChildCase>
        </MyCollapse>
        <MyCollapse title="家庭情况" iconPath="/static/de-family.png" name="2">
            <el-row>
              <el-col>
                <el-form-item label="相关证明附件" prop="proxyAttachIds">
                  <FileUpload :disabled="readOnly" v-model="detailData.proxyAttachIds"></FileUpload>
                </el-form-item>
              </el-col>
            </el-row>
        </MyCollapse>
        <MyCollapse title="备注信息" iconPath="/static/de-family.png" name="3">
          <el-row style="margin-bottom: 20px;">
            <el-col :span="12">
              <el-input v-model="detailData.remark" :disabled="readOnly" type="textarea" rows="3">
              </el-input>
            </el-col>
          </el-row>
        </MyCollapse>
      </el-collapse>
    </el-form>

    <msgDialog :showErrorIcon="true" width="30%" title="提示" :visible.sync="childExistsDialog" append-to-body :close-on-click-modal="false" @close="closeChildExistsDialog()">
      <span>
        患儿已存在，可在
        <span style="font-weight: bold">患儿管理-新增病种</span>
        后进行救助申请！
      </span>
      <span class="info" @click="toChildManageDetail">进入患儿详细信息页面>></span>
      <div slot="footer" class="dialog-footer" style="text-align: center;">
        <el-button type="primary" @click="closeChildExistsDialog()">关闭</el-button>
      </div>
    </msgDialog>
    <msgDialog :showErrorIcon="true" width="30%" title="提示" :visible.sync="childOtherHospitalExistsDialog" append-to-body
               :close-on-click-modal="false" @close="closeChildOtherHospitalExistsDialog()">
      <span style="font-weight: bold;font-size: 16px">患儿已在其他医院注册，请联系爱佑基金会管理人员。</span>
      <div slot="footer" class="dialog-footer" style="text-align: center;">
        <el-button type="primary" @click="closeChildOtherHospitalExistsDialog()">关闭</el-button>
      </div>
    </msgDialog>
    <msgDialog :showErrorIcon="true" width="30%" title="提示" :visible.sync="childCurrentHospitaldraftDialog" append-to-body
               :close-on-click-modal="false" @close="closeChildCurrentHospitaldraftDialog()">
      <span style="font-weight: bold;font-size: 16px">患儿已存在，请前往注册页面继续完善患儿信息。</span>
      <div slot="footer" class="dialog-footer" style="text-align: center;">
        <el-button type="primary" @click="closeChildCurrentHospitaldraftDialog()">关闭</el-button>
      </div>
    </msgDialog>
    <msgDialog :showErrorIcon="true" width="30%" title="提示" :visible.sync="childBaseInfoExistsDialog" append-to-body
               @close="closeChildBaseInfoExistsDialog">
      <span style="font-weight: bold;font-size: 16px">患儿基本信息重复！<br>存在基础信息重复患儿，请联系项目经理。</span>
      <div slot="footer" class="dialog-footer" style="text-align: center;">
        <el-button :loading="loading" type="primary" @click="addSimilarChildBaseInfo">确 定</el-button>
      </div>
    </msgDialog>
    <msgDialog :showErrorIcon="true" title="提示"  @close="showMsg5 = false" :visible.sync="showMsg5">
      <span style="font-weight: bold;font-size: 16px">患儿基本信息重复！<br>
        当前患儿基本信息重复
        <span style="color: #E8556F">疑似存在相似患儿且未审核</span>
        ，请联系项目经理。</span>
      <div slot="footer" >
        <el-button  type="primary"  @click="closeShowMsg5()">确 定</el-button>
      </div>
    </msgDialog>
    <msgDialog :showErrorIcon="true" title="提示"  width="630px" @close="confirmDialog = false" :visible.sync="confirmDialog">
      <table v-if="isWelfareBaby" border="0" cellspacing="0" cellpadding="0" style="margin: 0px auto 20px; width: 530px">
        <tr>
          <td style="height: 64px;">
            <div style="height: 64px; display: flex; align-items: center;">
              <span style="font-size: 16px;">该申请登录方式为：</span>
              <img style="width: 32px;" src="/static/alipay.png" />
              <span style="color: #226BF3; font-size: 16px; margin-left: 10px;"> 支付宝</span>
            </div>
          </td>
          <td rowspan="2" style="width: 160px; text-align: center;">
            <img style="width: 128px;" src="/static/msg/alipay.png" />
          </td>
        </tr>
        <tr>
          <td style="height: 64px;">
            <span style="font-size: 16px">请扫码或登录“爱佑救助通道”小程序 </span>
          </td>
        </tr>
      </table>
      <span v-else style="font-weight: bold;font-size: 16px">是否确认提交该救助申请？</span>
      <div slot="footer" >
        <el-button :loading="loading" @click="confirmDialog = false">取 消</el-button>
        <el-button :loading="loading" type="primary" @click="submitData()">确 定</el-button>
      </div>
    </msgDialog>
  </div>
</template>

<script>
  import {
    getHelpRequestDataById,
    saveProxyRequest,
    sbumitProxyRequest,
    getRequestAttachInfo,
    isCaptchaMatchApi,
    checkChildExistsApi,
    uniqueInHospitalNo,
    checkSimilarChildBaseInfo,
    addSimilarChildBaseInfoDai,
    uniqueInHospitalSerialNo
  } from "@/util/api";
  import ChapterHead from "@/components/business/ChapterHead.vue";
  import HospitalSelect from "@/components/business/HospitalSelect.vue";
  import DiseaseCascader from "@/components/business/DiseaseCascader.vue";
  import FileUpload from "@/components/business/FileUpload.vue";
  import dialogPanel from "@/components/business/dialogPanel";
  import MyCollapse from "@/components/business/MyCollapse";
  import LocationCascader from "@/components/business/LocationCascader.vue";
  import DictionarySelect from "@/components/business/DictionarySelect";
  import MsgCodeInput from "@/components/business/MsgCodeInput";
  import msgDialog from "@/components/business/msgDialog";

  import ChildCase from '../view/ChildCase'
  import {parseTime} from "../../../util/common";
  var idCard = (rule, value, callback) => {
    if (!value) {
      return callback(new Error("请输入身份证号"));
    } else {
      var p =
        /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
      if (!p.test(value)) {
        callback("身份证格式不正确");
      }
    }
    callback();
  };
  export default {
    components: {
      ChapterHead,
      MsgCodeInput,
      HospitalSelect,
      DiseaseCascader,
      FileUpload,
      dialogPanel,
      LocationCascader,
      DictionarySelect,
      msgDialog,
      MyCollapse,
      ChildCase
    },
    props: {
      dataMode: {
        type: String,
        default: 'add'
      },
      helpReqId: String
    },
    data() {

      var phoneVt = (rule, value, callback) => {
        if (!value) {
          return callback(new Error("请输入手机号"));
        } else {
          var p = /^1(3\d|4[5-9]|5[0-35-9]|6[2567]|7[0-8]|8\d|9[0-35-9])\d{8}$/;
          if (!p.test(value)) {
            callback("手机号格式不正确");
          }
          callback();
        }
      };
      return {
        childExists:{},
        showMsg5:false,
        isShow: this.dialogDetail,
        readOnly: this.dataMode != 'add',
        currentHospital: {},
        confirmDialog: false,
        isWelfareBaby: false,
        hasLoginAccount:'',
        isAngle: false,
        loading: false,
        childExistsDialog: false,
        childOtherHospitalExistsDialog: false,
        childBaseInfoExistsDialog: false,
        childCurrentHospitaldraftDialog:false,
        saveMode: 'save',
        lastHelpId: null,
        initialProject: null,
        localOptions: [],
        detailData: {},
        attachList: [],
        rules: {
          nation: [{ required: true, message: "请选择患儿民族", trigger: "change" }],
          curStages: [{ required: true, message: "请输入当前期次", trigger: "blur" }],
          fullAddr: [{ required: true, message: "请输入详细地址", trigger: "blur" }],
          liveAddr: [{ required: true, message: "请输入常住地址", trigger: "blur" }],
          childName: [{ required: true, message: "请输入患儿姓名", trigger: "blur" }],
          sex: [{ required: true, message: "请选择性别", trigger: "change" }],
          hasIdNumber: [{ required: true, message: "是否持有身份证", trigger: "change" }],
          idNumber: [{
            required: true,
            message: "请输入身份证号",
            trigger: "blur"
          },{
          //   pattern: /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,
          //   message: "请输入正确的身份证号码",
          //   trigger: "blur"
          // }, {
            validator:
            idCard, trigger: "blur"
          }],
          location: [{ required: true, message: "请选择户口所在地", trigger: "change" }],
          birthday: [{ required: true, message: "请选择出生日期", trigger: "blur" }],
          hospitalId: [{ required: true, message: "请选择救助医院", trigger: "blur" }],
          diseasesList: [{ required: true, message: "请选择病种", trigger: "blur" }],
          quotaType: [{ required: true, message: "请选择是否分期", trigger: "blur" }],
          // diseasesType: [{ required: true, message: "请选择病种类型", trigger: "blur" }],
          loginAccount: [{ required: true, message: "请输入手机号", trigger: "blur" }, { validator: phoneVt, trigger: "blur" }],
          captcha: [{ required: true, message: "请输入验证码", trigger: "blur" }],
          loginChannel: [{ required: true, message: "请选择登录方式", trigger: "blur" }],
          guardPhone: [{ required: true, message: "请输入监护人联系电话", trigger: "blur" }],
          guardIdNumber: [{ required: true, message: "请输入监护人身份证号", trigger: "blur" }, { validator: idCard, trigger: "blur" }],
          guardWechat: [{ required: true, message: "请输入监护人微信号", trigger: "blur" }],
          loginUserId: [{ required: true, message: "请输入支付宝账号", trigger: "blur" }],
          loginUserName: [{ required: true, message: "请输入支付宝姓名", trigger: "blur" }],
          loginIdNumber: [{ required: true, message: "请输入支付宝身份证号", trigger: "blur" }, { validator: idCard, trigger: "blur" }],
          loginRelation: [{ required: true, message: "请选择与患儿关系", trigger: "change" }],
          proxyAttachIds: [{ required: true, message: "请上传相关证明附件", trigger: "change" }],
        },
        pickerOptions: {
          disabledDate(time) {
            return time.getTime() > Date.now();
          }
        },
        hospAccount: false,
        checked:"checked",
        outherHospital:"outherHospitalExist",
        currentHospitalInfo:"currentHospitalInfoExist",
        similarChild:'similarChildExist',
        similarChildNocheck:"similarChildNocheckExist",
        reqModeInfo:""
      };
    },
    watch: {
      dialogDetail() {
        this.isShow = this.dialogDetail;
      },
      helpReqId(val) {
        if (val) {
          this.loadData(val)
        }
      }
    },
    mounted() {
      if (this.helpReqId) {
        this.loadData(this.helpReqId);
      }
    },
    methods: {
      loadData(id) {
        getHelpRequestDataById({
          helpReqId: id,
        }).then((res) => {
          let data = res.responseData;
          // 将新的查询结果传给父组件
          this.$emit("detailDataNew", data);
          if (data.county) {
            data.location = [data.province, data.city, data.county];
          }
          this.readOnly = data.apprStatus != 0 && data.apprStatus != 4;
          this.detailData = data;
          this.isWelfareBaby = this.detailData.isWelfareBaby == 1 || this.detailData.isAlipay == 1;
          // if(this.isWelfareBaby){
            if(this.detailData.loginAccount) this.hasLoginAccount = this.detailData.loginAccount
          // }
          let helpId = data.proxyCaseInfo ? data.proxyCaseInfo.helpId : null;
          if (helpId) {
            getRequestAttachInfo({
              helpReqId: id,
              attachType: '1'
            }).then(res => {
              if (res.msgCode == 200 && res.responseData.length > 0) {
                let attachList = res.responseData.map(d => {
                  return d.attachId;
                });
                this.$set(this.detailData, 'proxyAttachIds', attachList);
                this.$forceUpdate();
              }
            });
          }
        });
      },
      idNumberChange () {
        if (this.detailData.idNumber && this.detailData.idNumber.length > 14) {
          let year = this.detailData.idNumber.substring(6, 10);
          let month = this.detailData.idNumber.substring(10, 12);
          let day = this.detailData.idNumber.substring(12, 14);
          this.$set(this.detailData, 'birthday', new Date(year, parseInt(month) - 1, day));
        } else {
          this.$set(this.detailData, 'birthday', null);
        }
        this.checkSimilarChildBaseInfo();
      },
      diseaseChange(val, isBoby, isAngle, initialProject) {
        this.isWelfareBaby = isBoby;
        this.isAngle = isAngle;
        this.initialProject = initialProject
      },
      // 暂存
      saveData() {
        let params = this.getParams();
        let valid = this.validateParams(params.proxyCaseInfo);
        if (valid) {
          this.loading = true;
          this.saveMode = 'save';

          // 判断当前医院是否开启了自动接口调用，如开启则校验住院号是否唯一
          if (this.currentHospital.isAuto == 1 && params.hospitalId && params.inHospitalNo) {
            uniqueInHospitalNo({
              helpId: params.helpId,
              hospitalId: params.hospitalId,
              inHospitalNo: params.inHospitalNo,
              inHospitalTime: params.inHospitalTime,
            }).then(res => {
              if (res.msgCode == 200) {
                if (res.responseData == 1) {
                  this.checkChildExists(params, () => {
                    this.continueAddChild();
                  });
                } else {
                  this.$message.error('住院号已存在！')
                }
              }
            })
          } else {
            this.checkChildExists(params, () => {
              this.continueAddChild();
            });
          }

        }
      },
      // // 校验验证码是否匹配
      isCaptchaMatch() {
        let params = {
          phone: this.detailData.loginAccount,
          captcha: this.detailData.captcha
        }
        isCaptchaMatchApi(params).then(res => {
          if (res.msgCode == 200) {
            if(res.success){
              this.confirmDialog = true;
            }else{
              this.$message.error('验证码错误请重新输入')
            }
          }else{
            this.$message.error('验证码验证失败')
          }
        })

      },
      submitConfrim () {
        this.$refs.childCase.validate((caseValid) => {
          this.$refs["ruleForm"].validate(async (valid) => {
            if (caseValid && valid) {
              let params = this.getParams();
              //判断如果是自动对接，并且显示住院流水号，需要校验流水号
              if (this.currentHospital.isShowInHospitalNumber == 1 && this.currentHospital.isAuto) {
                try {
                  await this.uniqueInHospitalSerialNo(params);
                } catch (error) {
                  return; // 校验失败时终止流程
                }
              }
              // 判断当前医院是否开启了自动接口调用，如开启则校验住院号是否唯一
              if (this.currentHospital.isAuto == 1 && params.hospitalId) {
                if (!params.inHospitalNo) {
                  this.$message.error('住院号不能为空！');
                  return;
                }
                if (!params.inHospitalTime) {
                  this.$message.error('入院时间不能为空！');
                  return;
                }
                uniqueInHospitalNo({
                  helpId: params.helpId,
                  hospitalId: params.hospitalId,
                  inHospitalNo: params.inHospitalNo,
                  inHospitalTime: params.inHospitalTime,
                }).then(res => {
                  if (res.msgCode == 200) {
                    if (res.responseData == 1) {
                      //验证码验证
                  /*    if (this.isWelfareBaby) {
                        if (!this.hasLoginAccount || this.hasLoginAccount == this.detailData.loginAccount) {
                          this.confirmDialog = true;
                        } else {
                          this.isCaptchaMatch()
                        }
                      } else {
                        this.confirmDialog = true;
                      }*/
                      /**
                       * 按胡老师要求，只要填有登录手机号就必须校验验证码
                       */
                      if (this.isWelfareBaby && this.detailData.loginAccount){
                        this.isCaptchaMatch()
                      } else {
                        this.confirmDialog = true;
                      }
                    } else {
                      this.$message.error('住院号已存在！')
                    }
                  } else {
                    this.$message.error(res.msg);
                  }
                })
              } else {
                //验证码验证
          /*      if (this.isWelfareBaby) {
                  if (this.hasLoginAccount != ''|| this.hasLoginAccount == this.detailData.loginAccount) {
                    this.confirmDialog = true;
                  } else {
                    this.isCaptchaMatch()
                  }
                } else {
                  this.confirmDialog = true;
                }*/
                /**
                 * 按胡老师要求，只要填有登录手机号就必须校验验证码
                 */
                if (this.isWelfareBaby && this.detailData.loginAccount){
                  this.isCaptchaMatch()
                } else {
                  this.confirmDialog = true;
                }
              }
            }
          })
        });
      },
      // 提交
      submitData() {
        this.$refs.childCase.validate((caseValid) => {
          this.$refs["ruleForm"].validate((valid) => {
            if (caseValid && valid) {
              let params = this.getParams();
              if(params.hasIdNumber == 0){
                params.idNumber=''
              }
              let validPar = this.validateParams(params.proxyCaseInfo);
              if (validPar) {
                this.loading = true;
                this.saveMode = 'submit';
                this.checkChildExists(params, () => {
                  this.continueAddChild();
                });
                // this.continueAddChild();
                this.confirmDialog = false
              }
            }
          });
        });
      },
      checkChildExists(params, callback) {
        checkChildExistsApi(params).then(res => {
          this.loading = false;
          if (res.msgCode == 200) {
            if (res.responseData.childExistsCode == 0 || res.responseData.childExistsCode == 4) {
              callback();
            } else if (res.responseData.childExistsCode == 1) {
              this.childExistsDialog = true;
              this.lastHelpId = res.responseData.lastHelpId;
            } else if (res.responseData.childExistsCode == 2) {
              this.childOtherHospitalExistsDialog = true;
            } else if (res.responseData.childExistsCode == 3) {
              this.childBaseInfoExistsDialog = true;
            } else if (res.responseData.childExistsCode == 6 && res.responseData.childReqmode==1){
              this.childCurrentHospitaldraftDialog= true;
            }
          } else {
            this.$message.error(res.msg)
          }
        });
      },
      msgCodeValue(text){
        this.detailData.captcha = text
      },
      continueAddChild() {
        this.loading = true;
        let params = this.getParams();
        if(params.hasIdNumber == 0){
          params.idNumber=''
        }
        this.$emit('beforeSave');
        if (this.saveMode == 'submit') {
          params.resubmitFlag = params.apprStatus == 4 ? 1 : 0;
          sbumitProxyRequest(params).then((res) => {
            this.loading = false;
            this.childBaseInfoExistsDialog = false;
            this.$emit('complete');
            if (res.msgCode == 200) {
              this.$message({
                duration: 5000,
                message: res.msg,
                type: 'success'
              });
              this.back();
            } else {
              this.$message.error(res.msg);
            }
          });
        } else {
          saveProxyRequest(params).then((res) => {
            this.loading = false;
            this.childBaseInfoExistsDialog = false;
            this.$emit('complete');
            if (res.msgCode == 200) {
              this.$message({
                duration: 5000,
                message: res.msg,
                type: 'success'
              });
              this.detailData.helpReqId = res.responseData.helpReqId;
              this.detailData.childUid = res.responseData.childUid;
              this.back();
            } else {
              this.$message.error(res.msg);
            }
          });
        }
      },
      getParams() {
        if (this.detailData.location && this.detailData.location.length > 2) {
          this.detailData.province = this.detailData.location[0];
          this.detailData.city = this.detailData.location[1];
          this.detailData.county = this.detailData.location[2];
        }
        if (this.detailData.proxyAttachIds && this.detailData.proxyAttachIds.length > 0) {
          this.detailData.proxyAttachList = this.detailData.proxyAttachIds.map(d => {
            return {
              fileType: '1',
              attachId: d
            }
          })
        }
        // this.detailData.birthday = this.detailData.birthday ? this.parseTime(this.detailData.birthday, '{y}-{m}-{d}') : null;
        let caseData = this.$refs.childCase.getFormData() || {};
        this.detailData.hospitalId = caseData.hospitalId;
        this.detailData.quotaType = caseData.quotaType;
        this.detailData.totalStages = caseData.totalStages;
        this.detailData.curStages = caseData.curStages;
        if (this.isWelfareBaby) {
          this.detailData.loginChannel = 2;
        }

        if (caseData.diseasesIdList) {
          this.detailData.diseasesList = caseData.diseasesIdList.map(d => {
            return {
              diseasesId: d
            };
          });
        }
        // if (caseData.diseasesType) {
        //   this.detailData.diseasesType = caseData.diseasesType;
        // }
        this.detailData.isWelfareBaby = this.isWelfareBaby ? 1 : 0;
        if (this.isAngle) {
          delete this.detailData.totalStages;
          return {
            ...this.detailData,
            birthday: this.parseTime(this.detailData.birthday, '{y}-{m}-{d}'),
            proxyCaseInfo: caseData
          }
        } else {
          delete this.detailData.proxyCaseInfo;
          return {
            ...this.detailData,
            birthday: this.parseTime(this.detailData.birthday, '{y}-{m}-{d}'),
          };
        }
      },
      validateParams(proxyCaseInfo) {
        if (!this.detailData.childName) {
          this.$message.error('请填写患儿姓名');
          return false;
        }
        if (!this.detailData.sex) {
          this.$message.error('请选择性别');
          return false;
        }
        if (!this.detailData.birthday) {
          this.$message.error('请选择出生日期');
          return false;
        }
        if (this.detailData.hasIdNumber != 0 && this.detailData.hasIdNumber != 1) {
          this.$message.error('请选择是否有身份证');
          return false;
        }
        if (this.detailData.hasIdNumber == 1 && !this.detailData.idNumber) {
          this.$message.error('请填写患儿身份证');
          return false;
        }
        if (proxyCaseInfo && proxyCaseInfo.diagnosisDate && this.detailData.birthday > proxyCaseInfo.diagnosisDate) {
          this.$message.error('确诊日期不能小于出生日期');
          return false;
        }
        if (this.detailData.hasIdNumber == 1 && this.detailData.idNumber) {
          if (this.detailData.idNumber.length != 18) {
            this.$message.error('身份证格式不正确');
            return false;
          } else if (this.detailData.idNumber.substring(6, 14) != this.parseTime(this.detailData.birthday, '{y}{m}{d}')) {
            this.$message.error('出生日期与身份证号码中的日期不符');
            return false;
          }
        }
        if (!this.detailData.location || this.detailData.location.length < 1) {
          this.$message.error('请选择户口所在地');
          return false;
        }
        if(!this.detailData.hospitalId){
          this.$message.error('请选择救助医院');
          return false;
        }
        return true;
      },
      toChildManageDetail() {
        this.childExistsDialog = false;
        this.$emit('back');
        this.$router.push({
          path: '/child/Detail',
          query: {
            helpId: this.lastHelpId
          }
        })
      },
      hospitalChange (hospital) {
        this.currentHospital = hospital;
      },
      back() {
        // if (this.dataMode == 'add') {
        //   this.$router.go(-1);
        // } else {
          this.$emit('back');
        // }
      },
      //时时验证患儿是否存在相似
      checkSimilarChildBaseInfo(){
        this.checkSimalarYes();
        if((this.detailData.childName!=undefined && this.detailData.sex!=undefined
          &&  this.detailData.birthday !=undefined && this.detailData.location!=undefined) || ((this.detailData.idNumber && this.detailData.idNumber.length > 14) && this.detailData.hasIdNumber==1 )){

          if(this.detailData.location!=undefined){
            this.detailData.province = this.detailData.location[0]
            this.detailData.city = this.detailData.location[1]
            this.detailData.county = this.detailData.location[2]
          }
          //如果患儿已存在，提示新增病种（有身份证）
          checkChildExistsApi(this.detailData).then(res=>{
            this.loading = false;
            this.childExists=res.responseData;
            if ( this.childExists.childExistsCode==1){    //如果患儿已存在，提示新增病种（有身份证）
              this.childExistsDialog = true;
              this.lastHelpId = this.childExists.lastHelpId
            }else {
              //验证相似患儿是否是未审核状态
              checkSimilarChildBaseInfo({
                childName:this.detailData.childName,
                sex:this.detailData.sex,
                province:this.detailData.province,
                city:this.detailData.city,
                county:this.detailData.county,
                birthday: parseTime(this.detailData.birthday, '{y}-{m}-{d}')
              }).then(res => {
                this.loading = false;
                //提示当前患儿基本信息重复疑似存在相似患儿且未审核，请联系联系项目经理
                if (res.msgCode == 200 && res.msg == '验证失败'){
                  this.showMsg5=true;
                  this.checkSimalarNo();
                }else {
                  if (this.childExists.childExistsCode == 0 || this.childExists.childExistsCode == 4) {
                    //callback();
                  }else if (this.childExists.childExistsCode == 2) {
                    this.childOtherHospitalExistsDialog = true;
                  } else if (this.childExists.childExistsCode == 3) {
                    this.childBaseInfoExistsDialog = true;
                    this.checkSimalarYes();
                  }else if(this.childExists.childExistsCode == 6 && this.childExists.childReqmode==1){
                    this.childCurrentHospitaldraftDialog= true;
                  }
                }
              })

            }
          })
        }
      },
      addSimilarChildBaseInfo(){
        addSimilarChildBaseInfoDai({
          ...this.detailData,
          birthday: parseTime(this.detailData.birthday, '{y}-{m}-{d}')
        }).then(res => {
          this.loading = false;
          if (res.msgCode == 200) {
            this.childBaseInfoExistsDialog=false;
            this.$emit('checkSimalar',this.checked,this.similarChild);
          }
        })

      },
      //关闭提示
      closeChildBaseInfoExistsDialog(){
        this.childBaseInfoExistsDialog=false;
      },

      closeChildCurrentHospitaldraftDialog(){
        this.childCurrentHospitaldraftDialog=false;
        this.$emit('checkSimalar',this.checked,this.currentHospitalInfo);
      },
      //控制暂存与提交按钮(置灰)
      checkSimalarNo(){
        //this.$emit('checkSimalar',this.checked,this.outherHospital)
      },
      //控制暂存与提交按钮
      checkSimalarYes(){
        this.$emit('checkSimalar',"")
      },
      //当身份证有无显示有
      hasIdNumberVal(val){
        this.checkSimalarYes();
        if(val==1){
          //验证有身份证相似患儿情况
          this.checkSimilarChildBaseInfo();
        }
      },

      //关闭新增病种弹框
      closeChildExistsDialog(){
        this.childExistsDialog=false;
        this.checkSimalarNo();
      },

      //关闭其他医院存在相似患儿弹框
      closeChildOtherHospitalExistsDialog(){
        this.childOtherHospitalExistsDialog = false
        this.$emit('checkSimalar',this.checked,this.outherHospital);
      },
      //关闭存在相似患儿且未审核
      closeShowMsg5(){
        this.showMsg5=false;
        this.$emit('checkSimalar',this.checked,this.similarChildNocheck);
      },
      /**
       * 校验住院流水号
       */
      uniqueInHospitalSerialNo(params) {
        return new Promise((resolve, reject) => {
          if (!params.inHospitalSerialNo) {
            this.$message.error('住院流水号不能为空！');
            return reject();
          }

          uniqueInHospitalSerialNo({
            hospitalId: this.currentHospital.hospitalId,
            childName: params.childName,
            inHospitalTime: params.inHospitalTime,
            inHospitalSerialNo: params.inHospitalSerialNo,
          }).then(result => {
            if (result.msgCode != 200 || !result.responseData) {
              this.$message.error('住院流水号校验失败！');
              reject();
            } else {
              resolve();
            }
          });
        });
      }

    },
  };
</script>

<style lang="scss" scoped>
  @import "src/common/form";
  @import "src/common/dialog";

  .screen-view {
    display: flex;
    justify-content: flex-end;

    .screen-left {
      .child-head {
        width: 108px;
        height: 108px;
        border-radius: 50%;
        margin: auto 20px;
        background-color: #666666;
      }
    }

    .screen-right {
      width: 100%;
      height: auto;
    }
  }

  .photo {
    width: 8vw;
    height: 5vw;
    margin-right: 1vw;
    background-color: #666666;
  }

  .info {
    width: 100%;
    color: #E8556F;
    text-align: center;
    display: block;
    margin-top: 20px;
    cursor: pointer;
  }

  .my-radio /deep/ .el-radio{
    margin-right: 10px;
  }

  @import "src/common/common.scss";
</style>



// WEBPACK FOOTER //
// src/pages/child/hospital/HospitalChildInfo.vue